import { z } from 'zod';

const urlSchema = z
  .string()
  .url()
  .transform((value) => (value.endsWith('/') ? value.slice(0, -1) : value));

const configSchema = z.object({
  NEXT_PUBLIC_AG_URL: urlSchema,
  NEXT_PUBLIC_BACKEND_API_URL: urlSchema,
  NEXT_PUBLIC_BACKEND_API_KEY: z.string(),
  NEXT_PUBLIC_STATSIG_CLIENT_API_KEY: z.string(),
  NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY: z.string(),
  NEXT_PUBLIC_RUDDERSTACK_DATA_PLANE_URL: urlSchema,
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_DATA_PLANE_URL: urlSchema,
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_US: z.string(),
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_EU: z.string(),
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_UK: z.string(),
  NEXT_PUBLIC_VERCEL_ENV: z.enum(['development', 'preview', 'production']).optional()
});

export const config = configSchema.parse({
  NEXT_PUBLIC_AG_URL: process.env.NEXT_PUBLIC_AG_URL,
  NEXT_PUBLIC_BACKEND_API_URL: process.env.NEXT_PUBLIC_BACKEND_API_URL,
  NEXT_PUBLIC_BACKEND_API_KEY: process.env.NEXT_PUBLIC_BACKEND_API_KEY,
  NEXT_PUBLIC_STATSIG_CLIENT_API_KEY: process.env.NEXT_PUBLIC_STATSIG_CLIENT_API_KEY,
  NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY: process.env.NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY,
  NEXT_PUBLIC_RUDDERSTACK_DATA_PLANE_URL: process.env.NEXT_PUBLIC_RUDDERSTACK_DATA_PLANE_URL,
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_DATA_PLANE_URL:
    process.env.NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_DATA_PLANE_URL,
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_US:
    process.env.NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_US,
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_EU:
    process.env.NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_EU,
  NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_UK:
    process.env.NEXT_PUBLIC_RUDDERSTACK_IDENTITY_STITCHING_WRITE_KEY_UK,
  NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV
});
